var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-popup',{staticClass:"swipe-menu-modal p-10",style:({ maxHeight: '90%' }),attrs:{"position":"bottom","closeable":"","close-icon":"close","close-icon-position":"top-right"},on:{"close":_vm.closeModal},model:{value:(_vm.menuListModal),callback:function ($$v) {_vm.menuListModal=$$v},expression:"menuListModal"}},[_vm._t("body")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }